<template>
    <vx-expandable-card>
        <template v-slot:header> Cloning Targets </template>
        <template v-slot:content>
            <vx-selectable
                v-model="model.cloning_targets"
                :options="cloningTargets"
                @search="searchCloningTargets"
                @option:selected="selectTeams"
                @option:deselected="deselectTeams"
                label="name"
                size="lg"
                multiple
                :closeOnSelect="false"
            ></vx-selectable>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { VxExpandableCard, VxSelectable } from '@voxie/frontend-components';
import { ref } from 'vue';
import { adminCloningTargetsClient } from '~/services';
import debounce from '~/utils/debounce';

const model = defineModel('form', {
    type: Object,
    required: true,
});

const cloningTargets = ref([]);
const loadingCloningTargets = ref(false);
const searchCloningTargets = debounce((search) => {
    if (loadingCloningTargets.value) {
        return;
    }

    loadingCloningTargets.value = true;

    adminCloningTargetsClient
        .getCloningTargets({
            query: search,
            sort_dir: 'desc',
        })
        .then((response) => (cloningTargets.value = response.data.data))
        .finally(() => (loadingCloningTargets.value = false));
}, 350);

searchCloningTargets('');

const selectTeams = (cloningTargetsCollection) => {
    cloningTargetsCollection.forEach((cloningTarget) => {
        if (cloningTarget?.teams?.length) {
            // Filter teams which already exists.
            const filteredTeams = cloningTarget.teams.filter(
                (team) => !model.value.target_teams.some((targetTeam) => targetTeam.id === team.id)
            );
            model.value.target_teams = [...model.value.target_teams, ...filteredTeams];
        }
    });
};

const deselectTeams = (cloningTarget) => {
    // Filter curruent target teams.
    model.value.target_teams = model.value.target_teams.filter(
        (targetTeam) => !cloningTarget.teams.some((team) => team.id === targetTeam.id)
    );

    // Reselect teams from rest of targets.
    selectTeams(model.value.cloning_targets);
};
</script>
